import { render, staticRenderFns } from "./ArmeniansLoader.vue?vue&type=template&id=2b125a00&"
import script from "./ArmeniansLoader.vue?vue&type=script&lang=js&"
export * from "./ArmeniansLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports